export const iconFontAwesomeAlphabetD = (
	<i className="fa-solid fa-d"></i>
);
